










import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({})
export default class JdhInputArea extends Vue {

    @Prop({default: false, type: Boolean}) focus!: boolean
    @Prop({default: false, type: Boolean}) error!: boolean

    emitClick() {
        this.$emit('click')
    }

    get classes() {
        return [
            ... this.focus ? ['jdsc-input-area--focus'] : [],
            ... this.error ? ['jdsc-input-area--error'] : [],
        ]
    }

}
